<template>
    <div v-if="contract">
        <div class="content-header row">
            <div class="content-header-left col-12 mb-2 mt-1">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h5 class="content-header-title float-left pr-1 mb-0">{{ contract.name }}</h5>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb p-0 mb-0">
                                <li class="breadcrumb-item">
                                <router-link :to="{name: 'DashboardPage' }">
                                    <em class="bx bx-home-alt"></em>
                                </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link :to="{name: 'ContractsPage' }">Contracts</router-link>
                                </li>
                                <li class="breadcrumb-item active">{{ contract.name }}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <div class="row match-height">
                <div class="col-12">
                    <div class="text-right">
                        <router-link :to="{name: 'ContractsPage' }">
                            <button class="btn btn-secondary mb-1">
                                Go back to list
                            </button>
                        </router-link>
                    </div>

                    <div class="card">
                        <div class="card-content">
                            <div class="card-body">
                                <Alert
                                    v-if="errorText != ''"
                                    :text="errorText"
                                    type="danger"
                                    dismissable="false"
                                />
                                <div class="row">
                                    <div class="col-md-9 col-sm-12">
                                        <h2>{{ contract.name }}</h2>

                                        <button class="btn btn-primary mt-1" @click="downloadPDF()">
                                            Download PDF
                                        </button>
                                        <button class="btn btn-primary mt-1" @click="viewProposal()">
                                            View Proposal
                                        </button>
                                        <button class="btn btn-primary mt-1" @click="viewPayments()">
                                            View Payments
                                        </button>

                                        <br><br>

                                        <small style="white-space: nowrap;">
                                            Created on {{ contract.createdAt.split("T")[0] }} - ID: {{ contract.id }}
                                        </small>

                                        <br>

                                        Status:
                                        <div class="badge badge-info mr-1 mb-1 mt-1" v-if="contract.status === 'sent'">
                                            {{ contract.status }}
                                        </div>
                                        <div class="badge badge-success mr-1 mb-1 mt-1" v-if="contract.status === 'active'">
                                            {{ contract.status }}
                                        </div>
                                        <div class="badge badge-danger mr-1 mb-1 mt-1" v-if="contract.status === 'expired'">
                                            {{ contract.status }}
                                        </div>
                                        <div class="badge badge-secondary mr-1 mb-1 mt-1" v-if="contract.status === 'void'">
                                            {{ contract.status }}
                                        </div>


                                        <div class="mt-1">
                                            <h5 class="text-bold-500">Informations</h5>
                                            <div class="row mt-2">
                                                <div class="col-md-6 col-sm-12">
                                                <label for="">Rent Start</label>
                                                <input type="text" class="form-control" disabled :value="(contract.data) ? contract.data.rentStart.split('T')[0] : ''">
                                                </div>
                                                <div class="col-md-6 col-sm-12">
                                                <label for="">Contract Duration (In Months)</label>
                                                <input type="text" class="form-control" disabled :value="(contract.data) ? `${contract.data.contractDuration} months` : ''">
                                                </div>
                                            </div>
                                            <div class="row mt-2">
                                                <div class="col-md-6 col-sm-12">
                                                <label for="">Payment Recurrence (In Months)</label>
                                                <input type="text" class="form-control" disabled :value="(contract.data) ? `${contract.data.paymentRecurrence} months` : ''">
                                                </div> 
                                                <div class="col-md-6 col-sm-12">
                                                <label for="">Payment Method</label>
                                                <select class="select2 form-control" multiple="multiple" id="payment-method-select" disabled>
                                                    <option value="cash" :selected="paymentTypes.includes('cash')">Cash</option>
                                                    <option value="cheque" :selected="paymentTypes.includes('cheque')">Cheque</option>
                                                    <option value="wire_transfer" :selected="paymentTypes.includes('wire_transfer')">Wire Transfer</option>
                                                    <option value="mobile_transfer" :selected="paymentTypes.includes('mobile_transfer')">Mobile Transfer</option>
                                                    <option value="in_kind" :selected="paymentTypes.includes('in_kind')">In Kind</option>
                                                </select>
                                                </div>
                                            </div>
                                        </div>

                                        <hr />
                                        <h5 class="mt-2 text-bold-500">Users</h5>

                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item list-group-item-action border-0 d-flex align-items-center justify-content-between pl-0">
                                                <div class="list-left d-flex">
                                                    <div class="list-icon mr-1">
                                                        <div class="avatar bg-rgba-warning m-0 p-25">
                                                        <div class="avatar-content">
                                                            <span class="font-medium-1 text-warning">L</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="list-content">
                                                        <span class="list-title">
                                                            {{ (contract.landlord.name) ? contract.landlord.name : '-' }} ({{ (contract.landlord.email) ? contract.landlord.email : '-' }} / {{ (contract.landlord.phoneNumber) ? contract.landlord.phoneNumber : '-' }})
                                                        </span>

                                                        <small class="text-muted d-block">
                                                            User - <router-link :to="{name: 'SingleUserPage', params: {uuid: contract.landlord.uid} }">View Details</router-link>
                                                        </small>
                                                    </div>
                                                </div>
                                            </li>

                                            <li class="list-group-item list-group-item-action border-0 d-flex align-items-center justify-content-between pl-0" v-for="(tenant, index) in contract.tenants" :key="index">
                                                <div class="list-left d-flex">
                                                    <div class="list-icon mr-1">
                                                        <div class="avatar bg-rgba-warning m-0 p-25">
                                                        <div class="avatar-content">
                                                            <span class="font-medium-1 text-warning">T</span>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    <div class="list-content">
                                                        <span class="list-title">
                                                            {{ (tenant.name) ? tenant.name : '-' }} ({{ (tenant.email) ? tenant.email : '-' }} / {{ (tenant.phoneNumber) ? tenant.phoneNumber : '-' }})
                                                        </span>

                                                        <small class="text-muted d-block">
                                                            User - <router-link :to="{name: 'SingleUserPage', params: {uuid: tenant.uid} }">View Details</router-link>
                                                        </small>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div> <!-- END COLUMN BASIC INFORMATIONS -->

                                    <div class="col-md-9 col-sm-12" v-if="issues.length">
                                        <hr>
                                        <h5 class="mt-2 text-bold-500">Issues</h5>

                                        <ul class="list-group list-group-flush">
                                            <li class="list-group-item list-group-item-action border-0 d-flex align-items-center justify-content-between pl-0" v-for="(issue, index) in issues" :key="index">
                                                <div class="list-left d-flex">
                                                    <div class="list-content">
                                                        <span class="list-title">
                                                            <em class="bx bxs-circle font-small-1" :class="(issue.urgent) ? 'danger' : 'warning'"></em> {{ issue.title }}
                                                        </span>

                                                        <small class="text-muted d-block">
                                                            {{ (issue.status === 'open') ? 'Open' : 'Resolved' }} - <router-link :to="{name: 'IssuesSinglePage', params: {uuid: issue.id} }">View Details</router-link>
                                                        </small>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="col-md-9 col-sm-12">
                                        <hr />

                                        <h5 class="mt-2 text-bold-500">Property Informations <router-link :to="{name: 'EditHousePage', params: {uid: contract.property.uid} }" style="font-size: .6em; margin-left: 6px;">View Details</router-link></h5>
                                        <div class="mt-2">
                                            <HousePartialDetailsComponent :property="contract.property" v-if="contract.property" />
                                        </div>

                                        <hr />

                                        <h5 class="mt-2 text-bold-500">Contract Template</h5>
                                        <div class="mt-2">
                                            <TemplateDetailsComponent :template="contract.template" v-if="contract.template" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getCountryName } from "@/app-assets/js/get-countries.js";
    import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
    import Alert from "@/components/Alerts";
    import TemplateDetailsComponent from "@/components/Contracts/TemplateDetailsComponent";
    import HousePartialDetailsComponent from "@/components/Houses/HousePartialDetailsComponent";
    
    export default {

        data() {
            return {
                contract: null,
                contractUUID: this.$route.params.uuid,
                errorText: '',
                paymentTypes: [],
                issues: []
            }
        },

        components: {
            Alert,
            TemplateDetailsComponent,
            HousePartialDetailsComponent
        },

        methods: {
            getContractData() {
                $.blockUI({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                    backgroundColor: "#fff",
                    opacity: 0.8,
                    cursor: "wait",
                    },
                    css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: "transparent",
                    },
                });
                
                this.$apiCall.get(`/v1/contracts/contract/${this.contractUUID}`)
                .then(response => {
                    this.contract = response.data;
                    this.paymentTypes = (this.contract.data && this.contract.data.paymentTypes) ? this.contract.data.paymentTypes : [];
                    
                    setTimeout(() => {
                        $("#payment-method-select").select2({
                            placeholder: "No payment method selected..."
                        });
                    }, 500)
                    
                    this.getIssues();
                    $.unblockUI();
                })
                .catch(error => {
                    console.log(error);
                    $.unblockUI();
                })
            },

            downloadPDF() {
                $.blockUI({
                    message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                    overlayCSS: {
                    backgroundColor: "#fff",
                    opacity: 0.8,
                    cursor: "wait",
                    },
                    css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: "transparent",
                    },
                });

                this.errorText = '';

                this.$apiCall.get(`/v1/contracts/contract/${this.contractUUID}/download`, {
                    responseType: 'blob'
                })
                .then(res => {
                    const file = new Blob([res.data], {type: 'application/pdf'});
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    $.unblockUI();
                })
                .catch(error => {
                    this.errorText = `<strong>Ops!</strong> ${error.response.data.message}`;
                    $.unblockUI();
                })
            },

            getIssues() {
                this.$apiCall.get(`/v1/issues/contract/${this.contractUUID}`)
                .then(response => {
                    console.log(response);
                    this.issues = response.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
            },

            viewProposal() {
                window.open(`/contracts/proposals/${this.contract.proposal.id}`, '_blank');
            },

            viewPayments() {
                window.open(`/contracts?c=${this.contractUUID}`, '_blank');
            }
        },

        mounted() {
            this.getContractData();
        }
        
    }
</script>

<style scoped>
    .list-group .list-group-item-action:hover {
        background: #fff;
    }
</style>